export const ROW_TYPES = ['component', 'tabs', 'accordion', 'columns', 'field', 'anchor'] as const;

export const FIELD_TYPES = [
	'text',
	'textarea',
	'wysiwyg',
	'email',
	'password',
	'number',
	'color',
	'tel',
	'url',
	'select',
	'tree',
	'checkbox',
	'datetime',
	'date',
	'time',
	'file',
	'location',
] as const;

export const RULES = [
	'required',
	// strings
	'text',
	'email',
	'url',
	'date',
	'time',
	// numbers
	'number',
	// numbers or dates
	'compare',
] as const;

export const IMPLICIT_RULES = ['text', 'email', 'url', 'date', 'time', 'number'] as const;

export const BEHAVIOR_OPERATORS = ['EQ', 'NOT', '>', '<', 'IN', 'NOT_IN'] as const;
